import React, { Component } from "react"
import { Helmet } from "react-helmet"

import { Flex, Box } from "grid-styled"
import { ImgScaled } from "../styled-components"

import bilder from "../bilder/koeln"

class Koeln extends Component {
  renderImages = (start = 1, end = bilder.length - 1) => {
    let images = []

    for (let i = start; i <= end; i++) {
      images.push(
        <Box width={1} key={i}>
          <ImgScaled
            data-sizes="100vw"
            srcSet={bilder[i].min}
            // src={bilder[i].max}
            data-srcset={bilder[i].srcset}
            className="lazyload blur-up"
            alt={"Bild " + i}
          />
        </Box>
      )
    }
    return images
  }

  render() {
    return (
      <Flex flexDirection="column">
        {" "}
        <Helmet>
          <title>Fotografie Anders: Köln</title>
        </Helmet>
        {this.renderImages()}
      </Flex>
    )
  }
}

export default Koeln



// WEBPACK FOOTER //
// ./src/pages/Koeln.js